import { PlaylistAddOutlined } from "@mui/icons-material";
import { API_URLS, customAxios } from "../config";

export const getCustomersData = () =>
  customAxios
    .get(API_URLS.getCustomersData)
    .then((res) => res?.data)
    .catch((error) => error);

export const getDownloadCustomersData = () =>
  customAxios
    .get(API_URLS.getDownloadCustomersData)
    .then((res) => res?.data)
    .catch((error) => error);

export const getCustomersFormOptions = () =>
  customAxios
    .get(API_URLS.getCustomersFormOptions)
    .then((res) => res?.data)
    .catch((error) => error);

export const getCustomersFormContactStates = (payload) =>
  customAxios
    .get(API_URLS.getCustomersFormStates + payload.id)
    .then((res) => res?.data)
    .catch((error) => error);

export const getCustomersFormBillingStates = (payload) =>
  customAxios
    .get(API_URLS.getCustomersFormStates + payload.id)
    .then((res) => res?.data)
    .catch((error) => error);

export const postCustomersData = (payload) =>
  customAxios
    .post(API_URLS.postCustomersData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postCustomerFile = (payload) =>
  customAxios
    .post(API_URLS.postCustomerFile, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getCustomerEditData = (payload) =>
  customAxios
    .get(API_URLS.getCustomerEditData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postCustomerEditData = (payload) =>
  customAxios
    .post(API_URLS.getCustomerEditData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPayeeList = (payload) =>
  customAxios
    .get(API_URLS.getPayeeList, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getDownloadPayeeList = (payload) =>
  customAxios
    .get(API_URLS.getDownloadPayeeList, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postUploadPayeeList = (payload) =>
  customAxios
    .post(API_URLS.postUploadPayeeList, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getAddPayeeData = (payload) =>
  customAxios
    .get(API_URLS.getAddPayeeData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postAddPayeeData = (payload) =>
  customAxios
    .post(API_URLS.postAddPayeeData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPayeeLinkedEmployee = (payload) =>
  customAxios
    .get(API_URLS.getPayeeLinkedEmployee, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPayeeExpenseAccount = (payload) =>
  customAxios
    .post(API_URLS.getPayeeExpenseAccount, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPayeeContactStates = (payload) =>
  customAxios
    .get(API_URLS.getPayeeStates + payload.id)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPayeeBillingStates = (payload) =>
  customAxios
    .get(API_URLS.getPayeeStates + payload.id)
    .then((res) => res?.data)
    .catch((error) => error);

export const getEditPayeeData = (payload) =>
  customAxios
    .get(API_URLS.getEditPayeeData + payload.id)
    .then((res) => res?.data)
    .catch((error) => error);

export const postEditPayeeData = (payload) =>
  customAxios
    .post(API_URLS.postEditPayeeData + payload.id, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPayeePaymentInfoOptions = (payload) =>
  customAxios
    .get(API_URLS.getPayeePaymentInfoOptions + payload.id)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPayeePaymentInfoData = (payload) =>
  customAxios
    .get(API_URLS.getPayeePaymentInfoData)
    .then((res) => res?.data)
    .catch((error) => error);

export const postPayeePaymentInfoData = (payload) =>
  customAxios
    .post(API_URLS.postPayeePaymentInfoData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postDeletePayeePaymentInfoData = (payload) =>
  customAxios
    .post(API_URLS.postDeletePayeePaymentInfoData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPayeeDocumentData = (payload) =>
  customAxios
    .get(API_URLS.getPayeeDocumentData)
    .then((res) => res?.data)
    .catch((error) => error);

export const postPayeeDocumentData = (payload) =>
  customAxios
    .post(API_URLS.postPayeeDocumentData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const deletePayeeDocumentData = (payload) =>
  customAxios
    .post(API_URLS.deletePayeeDocumentData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const getPayeeBankingInfoData = (payload) =>
  customAxios
    .get(API_URLS.getPayeeBankingInfoData)
    .then((res) => res?.data)
    .catch((error) => error);

export const postPayeeBankingInfoData = (payload) =>
  customAxios
    .post(API_URLS.postPayeeBankingInfoData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const deletePayeeBankingInfoData = (payload) =>
  customAxios
    .post(API_URLS.deletePayeeBankingInfoData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const addPayeePendingApprovalData = (payload) =>
  customAxios
    .get(API_URLS.addPayeePendingApprovalData, payload)
    .then((res) => res?.data)
    .catch((error) => error);

export const postPayeeStatus = (payload) =>
  customAxios
    .post(API_URLS.postPayeeStatus, payload)
    .then((res) => res?.data)
    .catch((error) => error);

// ar invoices
export const postArInvoicesData = (payload) =>
  customAxios
    .post(API_URLS.postArInvoicesData, payload)
    .then((res) => res.data)
    .catch((error) => error);

export const getNewArInvoicesOptions = (payload) =>
  customAxios
    .get(API_URLS.getNewArInvoicesOptions, payload)
    .then((res) => res.data)
    .catch((error) => error);

export const getArInvoicesData = (payload) =>
  customAxios
    .post(API_URLS.getArInvoicesData, payload)
    .then((res) => res.data)
    .catch((error) => error);

export const getOutstandingArInvoicesData = (payload) =>
  customAxios
    .post(API_URLS.getOutstandingArInvoicesData, payload)
    .then((res) => res.data)
    .catch((error) => error);

export const getCancelledArInvoicesData = (payload) =>
  customAxios
    .post(API_URLS.getCancelledArInvoicesData, payload)
    .then((res) => res.data)
    .catch((error) => error);

export const getPaidArInvoicesData = (payload) =>
  customAxios
    .post(API_URLS.getPaidArInvoicesData, payload)
    .then((res) => res.data)
    .catch((error) => error);

export const getEditArInvoicesData = (payload) =>
  customAxios
    .get(API_URLS.getEditArInvoicesData + payload?.id, payload)
    .then((res) => res.data)
    .catch((error) => error);

export const postEditArInvoicesData = (payload) =>
  customAxios
    .post(API_URLS.postEditArInvoicesData + payload?.id, payload)
    .then((res) => res.data)
    .catch((error) => error);

export const postCancelArInvoice = (payload) =>
  customAxios
    .post(API_URLS.postCancelArInvoice, payload)
    .then((res) => res.data)
    .catch((error) => error);

export const getReceivablesList = (payload) =>
  customAxios
    .post(API_URLS.getReceivablesList, payload)
    .then((res) => res.data)
    .catch((error) => error);

export const getReceivableDetails = (payload) =>
  customAxios
    .post(API_URLS.getReceivableDetails + payload?.id, payload)
    .then((res) => res.data)
    .catch((error) => error);

export const postReceivePayments = (payload) =>
  customAxios
    .post(API_URLS.postReceivePayments, payload)
    .then((res) => res.data)
    .catch((error) => error);

export const getCreditNoteList = (payload) =>
  customAxios
    .post(API_URLS.getCreditNoteList, payload)
    .then((res) => res.data)
    .catch((error) => error);
